import React, { useState } from "react";
import confirmDelete from "../../../assets/Images/confirm delete.png"
import { ReactComponent as Cancel } from '../../../assets/Icons/Cancel.svg';
import { toast } from 'react-toastify';
import { axiosPostApi } from '../../../helpers/interceptorServices';
import { apiList } from '../../../helpers/apiList';
import CustomAlert from '../../../helpers/CustomAlert';
import confetti from "canvas-confetti";


const loggedInUserName = sessionStorage.getItem('username');
const DeleteFranchiseConfirmationModal = ({ isOpen, onClose,editData,fetchCustomerData,handleClose,CloseCreate }) => {
  const token = sessionStorage.getItem('token');
  
  const deleteCustomer = () => {
    const loggedInUserName = sessionStorage.getItem('username');
    const requestBody = {
      ...editData,
      username: loggedInUserName, 
      status: '3'  
    };

    axiosPostApi(apiList.DELETE_CUSTOMER_DATA, requestBody)
    .then((response) => {
      if (response?.status === 200 && response?.data?.respCode === '00') {
      // toast.success("Customer deleted successfully!");
       CustomAlert({
                  title: "Success",
                  text: response?.data?.message || "Customer deleted successfully!",
                  icon: "success",
                  confirmButtonText: "Ok"
                });
                 const canvas = document.createElement("canvas");
                                                canvas.style.position = "fixed";
                                                canvas.style.top = "0";
                                                canvas.style.left = "0";
                                                canvas.style.width = "100%";
                                                canvas.style.height = "100%";
                                                canvas.style.zIndex = "3000";
                                                document.body.appendChild(canvas);
                                    
                                                const confettiInstance = confetti.create(canvas, {
                                                  resize: true,
                                                  useWorker: true,
                                                });
                                    
                                                confettiInstance({
                                                  particleCount: 250,
                                                  spread: 100,
                                                  origin: { y: 0.6 },
                                                });
                                    
                                                setTimeout(() => {
                                                  document.body.removeChild(canvas);
                                                }, 3000);
                                                 fetchCustomerData(1);
      onClose();
          CloseCreate();

      handleClose();
     
      } else {
        CustomAlert({
          title: "Failed to delete customer",
          text: response.data?.message || 'Invalid credentials. Please try again!',
          icon: 'error',
          confirmButtonText: 'Retry'
        });
        onClose();
        handleClose();
      }
    })
    .catch((error) => {
      console.error("Error deleting customer", error);
      // toast.error("Failed to delete customer.");
    });
  };  

  if (!isOpen) {
    return null;
  }

  return (
    <div className="modal fade show" style={{ display: "block", backgroundColor: 'rgba(0, 0, 0, 0.5)', margin: 0 }}>
      <div className="modal-dialog">
        <div className="modal-content">
          <div className="modal-header" style={{ borderBottom: "none" }}>
            <span style={{ marginLeft: 'auto' }} >
              <Cancel onClick={onClose} />
            </span>
          </div>
          <div className="modal-body text-center">
            <img src={confirmDelete} alt="Warning" className="img-fluid mb-3" style={{ width: '250px' }} />
            <h5 className="modal-title">Confirm Deletion?</h5>
            <p className="mt-2">Information will be permanently erased and irretrievable.</p>
          </div>
          <div className="modal-footer justify-content-center">
            <button
              type="button"
              className="btn btn-back"
              data-bs-dismiss="modal"
              onClick={onClose}
            >
              Cancel
            </button>
            <button type="button" className="btn btn-danger" onClick={(e)=>deleteCustomer()}>
              Delete Permanently
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DeleteFranchiseConfirmationModal;